/**
 * @description: pcm播放
 * @author: lantf
 * @date: 2020/10/18 15:33
 */
class MnAudio {
  isPlaying = false;
  isVideoReady = false;
  constructor(option) {
    this.init(option);
  }
  videoReady() {
    this.isVideoReady = true;
  }
  init(option) {
    this.isPlaying = false;
    const defaults = {
      encoding: "16bitInt",
      channels: 1,
      sampleRate: 8000,
      flushingTime: 1000,
    };
    this.option = Object.assign({}, defaults, option);
    this.samples = new Float32Array(); // 保留兼容旧代码
    this.playingBuffers = []; // 正在播放的buffer列表
    this.interval = setInterval(
      this.flush.bind(this),
      this.option.flushingTime,
    );
    this.maxValue = this.getMaxValue();
    this.typedArray = this.getTypedArray();
    this.createContext();
    // 初始化基点时间
    this.baseTime = null;
    this.baseAudioTime = null;
    // 播放速度
    this.playbackRate = 1.0;
    this.defaultVolume = 0;
  }

  // 设置基点时间
  setBaseTime(timestamp) {
    this.baseTime = timestamp;
    this.baseAudioTime = this.audioCtx.currentTime;
  }

  getMaxValue() {
    const encodings = {
      "8bitInt": 128,
      "16bitInt": 32768,
      "32bitInt": 2147483648,
      "32bitFloat": 1,
    };

    return encodings[this.option.encoding]
      ? encodings[this.option.encoding]
      : encodings["16bitInt"];
  }

  getTypedArray() {
    const typedArrays = {
      "8bitInt": Int8Array,
      "16bitInt": Int16Array,
      "32bitInt": Int32Array,
      "32bitFloat": Float32Array,
    };

    return typedArrays[this.option.encoding]
      ? typedArrays[this.option.encoding]
      : typedArrays["16bitInt"];
  }

  createContext() {
    this.audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    this.gainNode = this.audioCtx.createGain();
    this.gainNode.gain.value = 1;
    this.gainNode.connect(this.audioCtx.destination);
    this.startTime = this.audioCtx.currentTime;
  }

  /* 倍速 */
  speed(speed) {
    // 更新全局播放速度
    if (speed < 0.1 || speed > 32) {
      return;
    }
    /* 如果速度超过4倍速设置最大4倍 */
    if (speed > 2) {
      speed = 1;
      /* 静音 */
      // this.volume(0, false);
      this.pause();
    } else {
      // this.volume(this.defaultVolume);
      this.resume();
    }
    this.playbackRate = speed;
    // console.log("倍速", speed);
    const now = this.playingBuffers[0];
    if (now) {
      now.bufferSource.playbackRate.value = this.playbackRate;
    }
  }

  isTypedArray(data) {
    return (
      data.byteLength && data.buffer && data.buffer.constructor == ArrayBuffer
    );
  }
  getNowPlayStamp() {
    const now = this.playingBuffers[0];
    if (now && now.startTimeStamp) {
      let diff = this.audioCtx.currentTime - now.ctxStartTimeStamp;
      return parseInt(+now.startTimeStamp + diff * 1000);
    }
    return -1;
  }
  offsetAudio(videoTime = 0) {
    const audioTime = this.getNowPlayStamp();
    if (audioTime == -1) return 0;
    if (videoTime == 0) return 0;
    const diffTime = audioTime - videoTime;
    return diffTime;
  }
  /* 重置音频如果音频落后的话进行重置 */
  resetAudioByTimeStamp(videoTime = 0) {
    if (videoTime == 0) return;
    while (true) {
      if (this.playingBuffers.length > 0) {
        // let now = this.playingBuffers.shift();
        let now = this.playingBuffers[0];
        console.log("this.playingBuffers", this.playingBuffers);
        console.log("now.startTimeStamp", +now.startTimeStamp, videoTime);
        if (!now.startTimeStamp || isNaN(+now.startTimeStamp)) {
          console.log("异常音频");
          return false;
        }
        if (+now.startTimeStamp > videoTime + 5000) {
          console.log(
            "视频落后, 没有对应的音频",
            now.startTimeStamp,
            videoTime,
          );
          return false;
        }
        let endTime = now.startTimeStamp + now.buffer.duration * 1000;
        // console.log(
        //   "这个buffer的endTime",
        //   endTime,
        //   now.startTimeStamp,
        //   now.buffer.duration,
        //   videoTime,
        // );
        if (endTime < videoTime) {
          this.playingBuffers.shift();
          this.isPlaying = false;
          console.log("停止过期的声音");
          try {
            now.bufferSource.onended = null;
            now.bufferSource.stop();
            now.bufferSource.disconnect();
          } catch (e) {
            now.bufferSource.disconnect();
          }
          continue;
        } else {
          /* 找到合适的了 */
          console.log("找到合适的");
          let offset = videoTime - now.startTimeStamp;
          offset = Math.max(offset, 0);
          // 添加结束事件监听器，清理已播放的buffer
          try {
            now.bufferSource.onended = null;
            now.bufferSource.stop();
          } catch (e) {
            now.bufferSource.disconnect();
          }
          const bufferSource = this.audioCtx.createBufferSource();
          bufferSource.buffer = now.buffer;
          bufferSource.connect(this.gainNode);
          now.bufferSource = bufferSource;
          now.bufferSource.start(0, offset / 1000);
          now.bufferSource.playbackRate.value = this.playbackRate;
          now.ctxStartTimeStamp = this.audioCtx.currentTime - offset / 1000;
          now.bufferSource.onended = () => {
            const old = this.playingBuffers.shift();
            const next = this.playingBuffers[0];
            if (next) {
              this.isPlaying = true;
              next.bufferSource.playbackRate.value = this.playbackRate;
              try {
                next.bufferSource.start();
              } catch (e) {}
              next.ctxStartTimeStamp = this.audioCtx.currentTime;
            } else {
              this.isPlaying = false;
            }
          };
          return true;
        }
      } else {
        return false;
      }
    }
  }
  feed(data, ti) {
    if (!this.isTypedArray(data)) return;
    data = this.getFormatedValue(data);
    if (this.samples.length == 0) {
      this.samplesTimeStamp = ti;
    }
    var tmp = new Float32Array(this.samples.length + data.length);
    tmp.set(this.samples, 0);
    tmp.set(data, this.samples.length);
    this.samples = tmp;
  }

  getFormatedValue(data) {
    const dataTyped = new this.typedArray(data.buffer);
    const float32 = new Float32Array(dataTyped.length);

    for (let i = 0; i < dataTyped.length; i++) {
      float32[i] = dataTyped[i] / this.maxValue;
    }
    return float32;
  }

  volume(volume, changeDefault = true) {
    if (changeDefault) {
      this.defaultVolume = volume;
    }
    this.gainNode.gain.value = volume;
  }

  destroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }

    // 清理所有正在播放的buffer
    this.playingBuffers.forEach((bufferInfo) => {
      try {
        bufferInfo.bufferSource.stop();
        bufferInfo.bufferSource.disconnect();
      } catch (e) {}
    });
    this.playingBuffers = [];

    this.samples = new Float32Array();
    this.samplesTimeStamp = 0;

    // 关闭音频上下文
    if (this.audioCtx) {
      this.audioCtx.close();
      this.audioCtx = null;
    }
  }

  flush() {
    if (!this.samples?.length) return;
    if (this.samples.length < 10) {
      return;
    }
    // 创建音频缓冲区并播放
    const bufferSource = this.audioCtx.createBufferSource();
    const length = this.samples.length / this.option.channels;
    const audioBuffer = this.audioCtx.createBuffer(
      this.option.channels,
      length,
      this.option.sampleRate,
    );
    let audioData;
    let channel;
    let sampleOffset;
    let i;
    let decrement;

    for (channel = 0; channel < this.option.channels; channel++) {
      audioData = audioBuffer.getChannelData(channel);
      sampleOffset = channel;
      decrement = 50;

      for (i = 0; i < length; i++) {
        audioData[i] = this.samples[sampleOffset];
        /* fadein */
        if (i < 50) {
          audioData[i] = (audioData[i] * i) / 50;
        }
        /* fadeout*/
        if (i >= length - 51) {
          audioData[i] = (audioData[i] * decrement--) / 50;
        }
        sampleOffset += this.option.channels;
      }
    }

    bufferSource.buffer = audioBuffer;
    bufferSource.connect(this.gainNode);

    // 记录正在播放的buffer信息
    const bufferInfo = {
      bufferSource: bufferSource,
      buffer: audioBuffer,
      startTimeStamp: +this.samplesTimeStamp,
    };

    this.playingBuffers.push(bufferInfo);

    // 启动播放
    if (!this.isPlaying && this.isVideoReady) {
      if (this.playingBuffers.length > 0) {
        let first = this.playingBuffers[0];
        try {
          first.bufferSource.start();
        } catch (e) {}
        first.bufferSource.playbackRate.value = this.playbackRate;
        first.ctxStartTimeStamp = this.audioCtx.currentTime;
        this.isPlaying = true;
      }
    }

    // 添加结束事件监听器，清理已播放的buffer
    bufferSource.onended = () => {
      const old = this.playingBuffers.shift();
      const next = this.playingBuffers[0];
      if (next) {
        next.bufferSource.playbackRate.value = this.playbackRate;
        try {
          next.bufferSource.start();
        } catch (e) {}
        next.ctxStartTimeStamp = this.audioCtx.currentTime;
      } else {
        this.isPlaying = false;
      }
    };
    this.samples = new Float32Array();
  }

  getTimestamp() {
    if (this.audioCtx) {
      return this.audioCtx.currentTime;
    } else {
      return 0;
    }
  }

  // play(data) {
  //   if (!this.isTypedArray(data)) {
  //     return;
  //   }

  //   data = this.getFormatedValue(data);
  //   if (!data.length) {
  //     return;
  //   }

  //   const bufferSource = this.audioCtx.createBufferSource();
  //   const length = data.length / this.option.channels;
  //   const audioBuffer = this.audioCtx.createBuffer(
  //     this.option.channels,
  //     length,
  //     this.option.sampleRate,
  //   );
  //   let audioData;
  //   let channel;
  //   let offset;
  //   let i;
  //   let decrement;

  //   for (channel = 0; channel < this.option.channels; channel++) {
  //     audioData = audioBuffer.getChannelData(channel);
  //     offset = channel;
  //     decrement = 50;
  //     for (i = 0; i < length; i++) {
  //       audioData[i] = data[offset];
  //       /* fadein */
  //       if (i < 50) {
  //         audioData[i] = (audioData[i] * i) / 50;
  //       }
  //       /* fadeout*/
  //       if (i >= length - 51) {
  //         audioData[i] = (audioData[i] * decrement--) / 50;
  //       }
  //       offset += this.option.channels;
  //     }
  //   }
  //   bufferSource.buffer = audioBuffer;
  //   bufferSource.connect(this.gainNode);
  //   // 记录正在播放的buffer信息
  //   const bufferInfo = {
  //     bufferSource: bufferSource,
  //     buffer: audioBuffer,
  //     startTimeStamp: this.samplesTimeStamp,
  //   };
  //   this.playingBuffers.push(bufferInfo);
  //   // 启动播放
  //   bufferSource.start();
  //   bufferSource.playbackRate.value = this.playbackRate;
  //   bufferInfo.ctxStartTimeStamp = this.audioCtx.currentTime;
  //   console.log("开始第一个",bufferInfo)
  //   // 添加结束事件监听器，清理已播放的buffer
  //   bufferSource.onended = () => {
  //     console.log(" this.playingBuffers", this.playingBuffers);
  //     this.playingBuffers.shift();
  //     const next = this.playingBuffers[0];
  //     if (next) {
  //       next.bufferSource.playbackRate.value = this.playbackRate;
  //       next.bufferSource.start();
  //       next.ctxStartTimeStamp = this.audioCtx.currentTime;
  //     }
  //   };
  // }

  pause() {
    if (this.audioCtx.state === "running") {
      this.audioCtx.suspend();
    }
  }

  clear() {
    while (true) {
      if (this.playingBuffers.length > 0) {
        console.log('this.playingBuffers',this.playingBuffers)
        const now = this.playingBuffers.shift();
        this.isPlaying = false;
        this.samplesTimeStamp = 0
        try {
          now.bufferSource.onended = null;
          now.bufferSource.stop();
          now.bufferSource.disconnect();
        } catch (e) {
          now.bufferSource.disconnect();
        }
      } else {
        return false;
      }
    }
  }

  resume() {
    if (this.audioCtx.state === "suspended") {
      this.audioCtx.resume();
    }
  }
}

export default MnAudio;
